import React from "react";
import ContentLoader from "../../components/contentLoader";

export default function Privacy() {
  return (
    <div className={`contentContainer`}>
        <ContentLoader docName={"privacy"} />
    </div>
  );
}
